// components/CategorySwiper.js
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules"; 
import { Link } from "react-router-dom";

const categories = [
    { name: "Nouveautés", icon: "fa-solid fa-newspaper", path: "/nouveautes" },
  // { name: "E-cartes de jeu", icon: "fa-solid fa-credit-card", path: "/Cartes__PSN" },
  // { name: "Cartes cadeaux Steam", icon: "fa-brands fa-steam-symbol", path: "/Cartes__itunes" },
    { name: "PS4", icon: "fa-brands fa-playstation", path: "/fr/PS4" },
      { name: "PS5", icon: "fa-brands fa-playstation", path: "/fr/PS5" },
        { name: "PSN", icon: "fa-brands fa-playstation", path: "/Cartes__PSN" },
        { name: "E-cartes cadeaux", icon: "fa-solid fa-gift", path: "/Cartes__PSN" },
  { name: "Cartes prépayées", icon: "fa-solid fa-credit-card", path: "/Cartes__itunes" },
  { name: "FIFA", icon: "fa-solid fa-futbol", path: "/fr/PS5" },
    { name: "Jeux", icon: "fa-solid fa-gamepad", path: "/JeuxVideos" },
  // { name: "Amazon", icon: "fa-brands fa-amazon", path: "/categorie/amazon" },
];

export default function CategorySwiper() {
  return (
    <div className="category-swiper">
      <Swiper
        modules={[Navigation]}
        navigation
        slidesPerView={5}
        spaceBetween={20}
        breakpoints={{
          640: { slidesPerView: 4 },
          768: { slidesPerView: 6 },
          1024: { slidesPerView: 8 },
        }}
      >
        {categories.map((cat, index) => (
          <SwiperSlide key={index}>
            <Link to={cat.path} className="cat-slide">
              <i className={cat.icon}></i>
              <span>{cat.name}</span>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}